module.exports = __webpack_public_path__ + "img/terry-zhang-falling.0b787f53.jpg";